module.exports = __webpack_public_path__ + "img/Jeysen_Yogaratnam.7209250e.png";